import React from "react";
import "./WishList.css";
import Breadcrumb_comp from "../Common-Component/Breadcrumb_comp/Breadcrumb_comp";
import { Swiper, SwiperSlide } from "swiper/react";
import Shop_by_shapes_cards from "../Common-Component/Shop_by_shapes_cards/Shop_by_shapes_cards";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBagShopping } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";

const WishList = () => {
  const breadcrumbData = [
    { name: "Home", link: "/home" },
    { name: "Wishlist" }, // No link for the last item (active)
  ];

  const slides = Array(9).fill(null);
  const dispatch = useDispatch();
  const wishlistData = useSelector((state) => state.wishlist.allWishlist);
  useEffect(() => {
    dispatch(getAllWishlist());
  }, [dispatch]);

  return (
    <section className="WishList">
      <div className="custom_container">
        <div className="breadcrump_holder">
          <div className="Breadcrumb_div">
            <Breadcrumb_comp data={breadcrumbData} />
          </div>
        </div>

        <div className="widhlist_swiper_div">
          <Swiper
            spaceBetween={40}
            slidesPerView={5}
            breakpoints={{
              0: {
                slidesPerView: 1.5,
                spaceBetween: 5,
              },
              420: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              485: {
                slidesPerView: 2.5,
                spaceBetween: 10,
              },
              640: {
                slidesPerView: 2.5,
                spaceBetween: 20,
              },
              991: {
                slidesPerView: 3.5,
                spaceBetween: 30,
              },
              1280: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
            }}
          >
            {wishlistData?.length > 0 &&
              wishlistData?.map((val) => {
                return (
                  <SwiperSlide>
                    <Shop_by_shapes_cards val={val}/>
                  </SwiperSlide>
                );
              })}
          </Swiper>
        </div>

        <div className="continue_shopping_div">
          <Link to={"/home"}>
            <p className="continue_shopping_text">
              <FontAwesomeIcon icon={faBagShopping} className="icon" />
              Continue Shopping
            </p>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WishList;
